class CommentInlineController {
  constructor() {
    this.bindEvents()
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const editBtn = e.target.closest('[data-action="click->commentInline#edit"]')
      if (editBtn) {
        e.preventDefault()
        this.startEdit(editBtn)
        return
      }

      const saveBtn = e.target.closest('[data-action="click->commentInline#save"]')
      if (saveBtn) {
        e.preventDefault()
        this.save(saveBtn)
        return
      }

      const cancelBtn = e.target.closest('[data-action="click->commentInline#cancel"]')
      if (cancelBtn) {
        e.preventDefault()
        this.cancel(cancelBtn)
      }
    })
  }

  startEdit(buttonEl) {
    const commentEl = buttonEl.closest('.comment')
    if (!commentEl) return
    const contentEl = commentEl.querySelector('.comment-content')
    if (!contentEl) return

    // Prevent duplicate editors
    if (contentEl.dataset.editing === '1') return
    contentEl.dataset.editing = '1'

    const originalHtml = contentEl.innerHTML
    const originalText = contentEl.innerText.trim()
    contentEl.dataset.originalHtml = originalHtml

    const updateUrl = buttonEl.dataset.updateUrl

    contentEl.innerHTML = `
      <div class="inline-edit">
        <textarea class="form-control" rows="3" data-comment-body>${this.escapeHtmlForTextarea(originalText)}</textarea>
        <div class="form-actions" style="margin-top:8px; display:flex; gap:8px;">
          <button class="button small" data-action="click->commentInline#save" data-update-url="${updateUrl}">Opslaan</button>
          <button class="button small cancel" data-action="click->commentInline#cancel">Annuleren</button>
        </div>
      </div>
    `
  }

  save(buttonEl) {
    const contentEl = buttonEl.closest('.comment').querySelector('.comment-content')
    const textarea = contentEl.querySelector('[data-comment-body]')
    const body = textarea.value
    const url = buttonEl.dataset.updateUrl

    fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ version_comment: { body } })
    })
      .then(res => {
        if (!res.ok) throw new Error('Update mislukt')
        return res.json().catch(() => ({}))
      })
      .then(() => {
        contentEl.innerHTML = this.formatBody(body)
        delete contentEl.dataset.editing
        delete contentEl.dataset.originalHtml
      })
      .catch(err => {
        alert('Opslaan mislukt: ' + err.message)
      })
  }

  cancel(buttonEl) {
    const contentEl = buttonEl.closest('.comment').querySelector('.comment-content')
    const originalHtml = contentEl.dataset.originalHtml
    if (originalHtml !== undefined) {
      contentEl.innerHTML = originalHtml
    }
    delete contentEl.dataset.editing
    delete contentEl.dataset.originalHtml
  }

  formatBody(text) {
    // Simple paragraph/linebreak formatting similar to simple_format
    const escaped = this.escapeHtml(text)
    const withBreaks = escaped.replace(/\n\n+/g, '</p><p>').replace(/\n/g, '<br>')
    return `<p>${withBreaks}</p>`
  }

  escapeHtml(text) {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
  }

  escapeHtmlForTextarea(text) {
    return this.escapeHtml(text).replace(/"/g, '&quot;')
  }
}

function initCommentInlineOnce() {
  if (window.__commentInlineInitialized) return
  window.__commentInlineInitialized = true
  new CommentInlineController()
}

document.addEventListener('DOMContentLoaded', initCommentInlineOnce)
document.addEventListener('turbo:load', initCommentInlineOnce)


